export default __webpack_public_path__ + "static/ghost_sinnister-8bc5def0428ee7f85c00cbb90af9d797.svg";